module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._v("Carregando...")])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/template-compiler.js?id=data-v-28fbed42!C:/Users/enzo.barros/software/azure/movemais.client/~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/external/login-ssa.vue
// module id = 2077
// module chunks = 1